module.exports = __webpack_public_path__ + "img/Set V2.622cb72d.jpg";